<ng-template #leftContent>
    <div class="btn__content -left">
        <ng-container *ngTemplateOutlet="left"></ng-container>
    </div>
</ng-template>

<ng-template #rightContent>
    <div class="btn__content -right">
        <ng-container *ngTemplateOutlet="right"></ng-container>
    </div>
</ng-template>

<ng-template #badge>
    <span class="btn__badge -left{{badgePosition ? ' -position-'+badgePosition : ''}}"
        [ngClass]="{'-left': badgeLeft !== null, '-right': badgeRight !== null}">
        <shared-badge class="btn__badge-elem" [size]="badgeSize ? badgeSize : size"
            [inverted]="feel == 'primary' || !feel">
            {{badgeLeft !== null ? badgeLeft : badgeRight}}
        </shared-badge>
    </span>
</ng-template>

<ng-template #content>
    <div class="btn__loader" *ngIf="loading">
        <ng-container [ngSwitch]="loading">

            <shared-loaders-checkmark class="btn__loader-success" *ngSwitchCase="'success'"
                [inverted]="!feel || feel === 'primary' || inverted">
            </shared-loaders-checkmark>

            <shared-loaders-error class="btn__loader-error" *ngSwitchCase="'error'"
                [inverted]="!feel || feel === 'primary' || inverted"></shared-loaders-error>

            <shared-loader-for-spinner class="btn__loader-progress" [inverted]="!feel || feel === 'primary' || inverted"
                *ngSwitchDefault>
            </shared-loader-for-spinner>

        </ng-container>
    </div>


    <ng-container *ngIf="left">
        <ng-container *ngTemplateOutlet="leftContent"></ng-container>
    </ng-container>

    <ng-container *ngIf="badgeLeft !== null">
        <ng-container *ngTemplateOutlet="badge"></ng-container>
    </ng-container>

    <ng-container *ngIf="iconLeft">
        <span class="btn__icon -left -icon-{{iconLeft}}">
            <shared-icon class="btn__icon-obj -left" [icon]="iconLeft"></shared-icon>
        </span>
    </ng-container>


    <span class="btn__label">
        <ng-content></ng-content>
    </span>

    <ng-container *ngIf="iconRight">
        <span class="btn__icon -right -icon-{{iconRight}}">
            <shared-icon class="btn__icon-obj -right" [icon]="iconRight"></shared-icon>
        </span>
    </ng-container>

    <ng-container *ngIf="badgeRight !== null">
        <ng-container *ngTemplateOutlet="badge"></ng-container>
    </ng-container>

    <ng-container *ngIf="right">
        <ng-container *ngTemplateOutlet="rightContent"></ng-container>
    </ng-container>

</ng-template>

<ng-template #forButton>
    <button [tabindex]="tabindex" (mouseleave)="isHovering = false" (mouseenter)="isHovering = true" [attr.form]="form"
        (click)="handleButtonClick($event)" [type]="type" [name]="name" [attr.for]="for" [disabled]="disabled"
        class="btn{{classes ? ' '+classes : ''}} -{{feel}} -type-btn{{size ? ' -size-'+size : ''}}{{loading ? ' -loading-status-' + loading : ''}}{{width ? ' -width-'+width : ''}}"
        [title]="title"
        [ngClass]="{'is-hovering': isHovering, '-has-left-content': left, '-has-right-content': right,'-no-paddings': !paddings,'-extended': width === 'extended','is-loading': loading, '-icon-right': iconRight, '-icon-left': iconLeft, 'is-disabled': disabled, '-inverted': inverted, '-has-badge': (badgeLeft !== null || badgeRight !== null) && !badgePosition, '-has-badge-positioned': badgePosition, '-has-badge-left': badgeLeft !== null && !badgePosition, '-has-badge-right': badgeRight !== null && !badgePosition}">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>
</ng-template>



<ng-template #forLink>

    <a [tabindex]="tabindex" (mouseleave)="isHovering = false" (mouseenter)="isHovering = true"
        (click)="handleButtonClick($event)" [routerLink]="routerLink"
        class="btn{{classes ? ' '+classes : ''}} -{{feel}} -type-link{{size ? ' -size-'+size : ''}}{{loading ? ' -loading-status-' + loading : ''}}{{width ? ' -width-'+width : ''}}"
        [attr.role]="role" [title]="title"
        [ngClass]="{'is-hovering': isHovering, '-has-left-content': left, '-has-right-content': right,'-no-paddings': !paddings, 'is-loading': loading, '-icon-right': iconRight, '-icon-left': iconLeft, 'is-disabled': disabled, '-inverted': inverted, '-has-badge': (badgeLeft !== null || badgeRight !== null) && !badgePosition, '-has-badge-positioned': badgePosition, '-has-badge-left': badgeLeft !== null && !badgePosition, '-has-badge-right': badgeRight !== null && !badgePosition}">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>

</ng-template>

<ng-container *ngTemplateOutlet="routerLink ? forLink : forButton"></ng-container>